import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { Activity, TrendingUp, ShoppingBag, Circle } from 'lucide-react';

const ICONS = {
  investment: TrendingUp,
  order: ShoppingBag,
};

const timeAgo = (iso) => {
  if (!iso) return '';
  const diffSec = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diffSec < 60) return 'just now';
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
  return `${Math.floor(diffSec / 86400)}d ago`;
};

const ActivityFeed = ({ activity }) => {
  if (!activity || activity.length === 0) {
    return (
      <Card data-testid="activity-empty">
        <CardContent className="p-5 text-center text-sm text-gray-500">
          <Activity className="h-6 w-6 mx-auto mb-2 text-gray-300" aria-hidden="true" />
          No recent activity
        </CardContent>
      </Card>
    );
  }

  return (
    <Card data-testid="activity-feed">
      <CardContent className="p-5">
        <p className="font-semibold text-sm flex items-center gap-2 mb-3">
          <Activity className="h-4 w-4 text-green-600" aria-hidden="true" />
          Recent activity
        </p>
        <div className="space-y-3">
          {activity.map((a, i) => {
            const Icon = ICONS[a.kind] || Circle;
            return (
              <div key={`${a.ref}-${i}`} className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0">
                  <Icon className="h-4 w-4 text-gray-500" aria-hidden="true" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{a.title}</p>
                  <p className="text-xs text-gray-500 truncate">{a.subtitle}</p>
                  <p className="text-[10px] text-gray-400 mt-0.5">{timeAgo(a.ts)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default ActivityFeed;
